<template>
  <div ref="container"></div>
</template>

<script>
export default {
  name: 'TelegramLogin',
  props: {
    mode: {
      type: String,
      required: true, // 'callback' | 'redirect'
    },
    telegramLogin: {
      type: String,
      required: true,
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    requestAccess: {
      type: String,
      default: 'read',
    },
    size: {
      type: String,
      default: 'large',
    },
    userpic: {
      type: Boolean,
      default: true,
    },
    radius: String,
  },
  emits: ['callback'],
  mounted() {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://telegram.org/js/telegram-widget.js?22'
    script.setAttribute('data-telegram-login', this.telegramLogin)
    script.setAttribute('data-size', this.size)
    script.setAttribute('data-request-access', this.requestAccess)
    if (this.radius) script.setAttribute('data-radius', this.radius)
    if (!this.userpic) script.setAttribute('data-userpic', 'false')
    if (this.mode === 'callback') {
      window.onTelegramAuth = user => this.$emit('callback', user)
      script.setAttribute('data-onauth', 'onTelegramAuth(user)')
    } else {
      script.setAttribute('data-auth-url', this.redirectUrl)
    }
    this.$refs.container.appendChild(script)
  },
}
</script>
